import { NO_ERRORS_SCHEMA, NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { LocaleService } from '../core/services/locale/locale.service';
import { FavouritesModule } from '../favourites/favourites.module';
import * as criticalLangData from '../lazy-modules/locale/translations/en-US/critical-lang-data';
import { LdFlag1Component } from '../sb/components/launchDarkly/ld-flag1.component';
import { LdFlag2Component } from '../sb/components/launchDarkly/ld-flag2.component';
import { SharedModule } from '../shared/shared.module';
// Vanilla overrides
import { BmaMainComponent } from './components/bmaMain/bma-main.component';
import { HomeComponent } from './components/home/home.component';
import { BmaInit } from './services/bmaRunService/bma-init';
import { BmaRunService } from './services/bmaRunService/bma-run.service';

@NgModule({
    imports: [SharedModule, FormsModule, FavouritesModule, LdFlag1Component, LdFlag2Component],
    providers: [
        BmaRunService,
        provideAppInitializer(() => {
            const initializerFn = BmaInit(inject(BmaRunService));
            return initializerFn();
        }),
    ],
    declarations: [HomeComponent, BmaMainComponent],
    exports: [BmaMainComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class BmaModule {
    constructor(private localeService: LocaleService) {
        this.localeService.setLangData(criticalLangData);
    }
}
